// extracted by mini-css-extract-plugin
export default {"Collapse":"RqnULg1z"};